import { Controller } from './Controller';
document.addEventListener('DOMContentLoaded', main);

async function main() {
	new Controller();
}
